<template>
  <div class="ml-0 block">
    <h1 class="h2 mb-3">Committee Secretaries</h1>
    <div class="text-center p-2" v-if="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!isLoading">
      <div role="alert" class="alert alert-warning" v-if="errors">{{ errors }}</div>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <label>Select a Secretary</label>
          <vue-bootstrap-typeahead
            :data="secretaries"
            v-model="secretariesSearch"
            :serializer="s => s.first_name + ' ' + s.last_name"
            placeholder="Start typing..."
            @hit="selectedSecretary = $event"
          />
          <div class="invalid-tooltip">Please include the Secretary.</div>
        </div>

        <div class="col-12 col-md-6 form-group button-add-secretary-wrapper">
          <button :class="['btn btn-block button-add-secretary', processing ? 'btn-primary-dark' : 'btn-primary']"
                  @click="handleAddSecretary" :disabled="processing">
            {{ processing ? '' : 'Add Secretary' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span
              class="sr-only">Loading...</span></div>
          </button>
        </div>

        <div class="col-10 col-md-5 form-group">
          <div class="secretaries-list-item" v-for="(secretary, index) in addedSecretaries">
            <div>{{ secretary.first_name + ' ' + secretary.last_name }}</div>
            <div>
              <button class="btn btn-sm button-remove-secretary" :key="secretary.id" :ref="'secretary-item'"
                      @click="removeSecretary(secretary.id, index)">{{ removeProcessing ? '' : 'Remove' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from "lodash"

export default {
  name: 'CommitteeDetailsSecretaries',
  props: ['committeeId'],
  components: {
    VueBootstrapTypeahead
  },
  data() {
    return {
      committee: null,
      user: localStorage.role,
      processing: false,
      errors: '',
      errorStatus: '',
      secretaries: [],
      secretariesSearch: '',
      selectedSecretary: null,
      addedSecretaries: '',
      removeProcessing: false,
      committeeDetails: null,
      isLoading: true
    }
  },
  methods: {
    getSecretaries(search_term) {
      if (!search_term) {
        this.secretaries = []
      } else {
        axios.get(`${this.$api}/admin/secretaries/list`, { params: { search_term } })
          .then((response) => {
            if (response.data.status === 'success') {
              this.errors = ''
              this.secretaries = response.data.data
            } else {
              this.errors = 'Something went wrong. Please reload the page.'
            }
          })
      }
    },
    handleAddSecretary() {
      this.processing = true
      if (this.selectedSecretary) {
        axios.post(`${this.$api}/admin/committee/${this.committee.id}/add-secretary`, { secretary_id: this.selectedSecretary.id })
          .then((response) => {
            if (response.data.status === 'success') {
              this.processing = false

              this.errors = ''
              if (this.selectedSecretary) {
                this.addedSecretaries.push(this.selectedSecretary)
              }
              this.selectedSecretary = null
            } else {
              this.errors = 'Something went wrong. Please reload the page.'
            }
          })
      }
      this.processing = false
    },
    removeSecretary(secretary_id, index) {
      this.$refs['secretary-item'][index].setAttribute('disabled', 'disabled')
      axios.post(`${this.$api}/admin/committee/${this.committee.id}/remove-secretary`, { secretary_id })
        .then((response) => {
          if (response.data.status === 'success') {
            this.addedSecretaries = this.addedSecretaries.filter(secretary => secretary.id !== secretary_id)
            this.errors = ''
          } else {
            this.errors = 'Something went wrong. Please reload the page.'
          }
        })
    },
    getCommittee(id) {
      axios.get(`${this.$api}/admin/committee-details/${id}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.committeeDetails = response.data.data
            this.isLoading = false
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.isLoading = false
        })
    }
  },

  mounted() {
    this.getCommittee(this.committeeId)
  },
  watch: {
    committeeDetails() {
      this.committee = { ...this.committeeDetails }
      this.addedSecretaries = this.committeeDetails.secretaries
    },
    // eslint-disable-next-line func-names
    secretariesSearch: _.debounce(function (value) {
      this.getSecretaries(value)
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.button-add-secretary {

  @media only screen and (min-width: 768px) {
    max-width: 180px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
}

.button-add-secretary-wrapper {
  display: flex;
  align-items: end;
  padding-bottom: 1px;
}

.button-remove-secretary {
  color: var(--primary);
}

.secretaries-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.block {
  margin-bottom: 25px;
}
</style>
<style>
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
  -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Committees/Edit/components/CommitteeDetailsSecretaries.vue